import * as _ from 'lodash';
import { Component, OnInit, Input, Optional, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FieldConventionService, LookupPipe, LookupService, dateFormatter } from 'src/app/stp/stp-app/forms';
import { FIELD_DATA } from '../field-data.directive';

@Component({
  selector: 'stp-field',
  templateUrl: './field.component.html',
  styleUrls: ['./field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldComponent implements OnInit {

  static defaultContent = '-';

  @Input() fieldData?: any;
  @Input() fieldName?: string;
  @Input() label: string;
  content: any;
  isMultilineString = false;
  isObservable = false;

  constructor(
    @Optional() @Inject(FIELD_DATA) private injectedFieldData: any,
    private fieldConventionService: FieldConventionService,
    private lookupService: LookupService,
    private lookupPipe: LookupPipe) { }

  ngOnInit() {
    this.fieldData = this.fieldData || this.injectedFieldData;

    if (this.fieldName && this.fieldData) {
      this.setContentFromFieldData();
    }

    this.setLabel();
  }

  private setContentFromFieldData() {
    this.content = _.get(this.fieldData, this.fieldName) || FieldComponent.defaultContent;

    this.applyConventionMultiline();
    this.applyConventionLookup();
    this.applyConventionDate();
    this.applyConventionDefaultValueIfNull();
  }

  private applyConventionMultiline() {
    if (!(typeof (this.content) === 'string')) { return; }

    if (!!this.content && this.content.indexOf('\n') !== -1) {
      this.isMultilineString = true;
    }
  }

  private applyConventionLookup() {
    if (!this.fieldName) { return; }

    if (this.fieldConventionService.isLookupField(this.fieldName) && typeof (this.content) === 'number') {
      this.content = this.lookupPipe.transform(this.content, this.lookupService.getDefaultLookupName(this.fieldName));
      this.isObservable = true;
    }
  }

  private applyConventionDate() {
    if (this.fieldConventionService.isDate(this.content)) {
      this.content = dateFormatter(this.content);
    }
  }

  private applyConventionDefaultValueIfNull()  {
    if (!this.content) {
      this.content = FieldComponent.defaultContent;
    }
  }

  private setLabel() {
    if (this.label) {
      return;
    }

    if (this.fieldName) {
      this.label = this.fieldConventionService.getDefaultLabel(this.fieldName);
    }
  }
}
